module.exports = __webpack_public_path__ + "static/media/features-compliance.d2174e30.png";